/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { Input, Modal, Loader } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
//import cx from 'classnames';
import ClarLoader from '../Loader/Loader';
import api from '../../api';
import ResultRenderer from '../ResultRenderer/ResultRenderer';
import TimezonePicker from '../TimezonePicker/TimezonePicker';
import MAPPING from '../TimezonePicker/default_timezone';

class TimeZoneSystem extends Component {
  constructor(props) {
    super(props);
    this.typingTimeout = null;
    this.state = {
      isLoadTimeZone: false,
      isLoading: false,
      isOpenModal: false,
      isLoader: false,
      isDrawMap: false,
      isShowResult: false,
      timezoneList: [],
      selectedTime: {
        name: '',
        zone: '',
        id: '',
      },
      defaultTime: {},
      //selectedPoint: '',
      //filteredJson: [],
    };
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearchFocus = this.handleSearchFocus.bind(this);
    this.handleSearchBlur = this.handleSearchBlur.bind(this);
    this.handleResultSelect = this.handleResultSelect.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.setTimeZone = this.setTimeZone.bind(this);
    this.generateMapCallback = this.generateMapCallback.bind(this);
    this.setValue = this.setValue.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    const { isLoadTimeZone } = this.state;
    document.addEventListener('mousedown', this.handleClickOutside);
    if (!isLoadTimeZone) {
      this.getCurrentTimeZone();
    }
    this.getTimeZoneList();
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
    clearTimeout(this.typingTimeout);
  }

  handleSave() {
    this.setState({
      isOpenModal: true,
    });
  }

  handleSearchChange = (e, { value }) => {
    this.setState({
      isLoading: true,
      selectedTime: {
        id: 'searching',
        name: value,
        zone: '',
      },
      timezoneList: [],
    });

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    this.typingTimeout = setTimeout(() => {
      if (value.length < 1) {
        value = '';
        return this.setState({
          selectedTime: {
            id: '',
            name: '',
            zone: '',
          },
          isLoading: false,
        });
      }
      this.getTimeZoneList();
    }, 1000);
  };

  handleSearchFocus() {
    setTimeout(() => {
      this.setState({
        timezoneList: [],
        isLoading: false,
      }, () => {
        this.getTimeZoneList();
      });
    }, 300);

    this.setState({
      isShowResult: true,
    });
  }

  handleSearchBlur() {
    const { selectedTime, defaultTime } = this.state;

    if (typeof selectedTime.id !== 'number') {
      this.setState({
        selectedTime: {
          id: 'default',
          name: defaultTime.name,
          zone: defaultTime.zone,
        },
        isShowResult: false,
        timezoneList: [],
        isLoading: false,
      });
    } else {
      this.setState({
        isShowResult: false,
        timezoneList: [],
        isLoading: false,
      });
    }
  }

  handleResultSelect = (e, result) => {
    const data = MAPPING.filter((item) => {
      return item.name === result.name;
    });

    if (result.name === 'Asia/Seoul') {
      this.setState({
        selectedTime: {
          id: result.id,
          name: result.name,
          zone: 'Asia/Seoul',
        },
        defaultTime: {
          id: result.id,
          name: result.name,
          zone: 'Asia/Seoul',
        },
        isShowResult: false,
        isLoading: false,
        timezoneList: [],
      });
    } else if (result.name === 'Srednekolymsk') {
      this.setState({
        selectedTime: {
          id: result.id,
          name: 'YAKT',
          zone: 'Asia/Yakutsk',
        },
        defaultTime: {
          id: result.id,
          name: 'YAKT',
          zone: 'Asia/Yakutsk',
        },
        isShowResult: false,
        isLoading: false,
        timezoneList: [],
      });
    } else {
      this.setState({
        selectedTime: {
          id: result.id,
          name: result.name,
          zone: data[0].zone,
        },
        defaultTime: {
          id: result.id,
          name: result.name,
          zone: data[0].zone,
        },
        isShowResult: false,
        isLoading: false,
        timezoneList: [],
      });
    }
  };

  setValue(arr, zonename) {
    const selectedTimezone = MAPPING.filter((item) => {
      return item.zone === zonename;
    });

    if (selectedTimezone.length !== 0) {
      const findName = selectedTimezone.filter((item) => {
        return zonename.indexOf(item.name) > -1;
      });
      if (findName.length !== 0) {
        this.setState({
          selectedTime: {
            id: '',
            name: findName[0].name,
            zone: zonename,
          },
          defaultTime: {
            id: '',
            name: findName[0].name,
            zone: zonename,
          },
        });
      } else {
        this.setState({
          selectedTime: {
            id: '',
            name: selectedTimezone[0].name,
            zone: zonename,
          },
          defaultTime: {
            id: '',
            name: selectedTimezone[0].name,
            zone: zonename,
          },
        });
      }
    } else {
      const zoneData = MAPPING.map((item) => {
        return item.zone;
      });
      const findData = arr.filter((item) => {
        return zoneData.indexOf(item.timezone) > -1;
      });

      const filtername = MAPPING.filter((item) => {
        return item.zone === findData[0].timezone;
      });

      if (findData.length !== 0) {
        this.setState({
          selectedTime: {
            id: '',
            name: filtername[0].name,
            zone: zonename,
          },
          defaultTime: {
            id: '',
            name: filtername[0].name,
            zone: zonename,
          },
        });
      } else {
        console.log(zonename);
      }
    }
  }

  setTimeZone() {
    const { selectedTime } = this.state;

    const data = {
      location: selectedTime.name,
    };

    this.setState({
      isLoader: true,
    }, () => {
      api
        .setTimeZone(data)
        .then(() => {
          this.setState({
            isLoader: false,
            isOpenModal: false,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  getCurrentTimeZone() {
    this.setState({
      isLoadTimeZone: true,
    }, () => {
      api
        .getCurrentTimeZone()
        .then((response) => {
          const data = response.response;
          if (typeof data.location === 'undefined' || data.location === '' || data.location === 'Etc/UTC') {
            this.setState({
              selectedTime: {
                name: 'Seoul',
                zone: 'Asia/Seoul',
                id: 'default',
              },
              defaultTime: {
                name: 'Seoul',
                zone: 'Asia/Seoul',
                id: 'default',
              },
              isLoadTimeZone: false,
              isDrawMap: true,
            });
          } else {
            this.setState({
              selectedTime: {
                name: data.location,
                zone: data.zone,
                id: 'default',
              },
              defaultTime: {
                name: data.location,
                zone: data.zone,
                id: 'default',
              },
              isLoadTimeZone: false,
              isDrawMap: true,
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            isLoadTimeZone: false,
            isDrawMap: false,
          });
        });
    });
  }

  getTimeZoneList() {
    const { selectedTime } = this.state;
    this.setState({
      isLoading: true,
    }, () => {
      api
        .getTimeZoneList(
          {
            continent: '',
            search: selectedTime.name,
          }
        )
        .then((response) => {
          const data = response.response.map((item, index) => {
            return {
              id: index,
              name: item,
              zone: '',
            };
          });

          this.setState({
            isLoading: false,
            timezoneList: data,
          });
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }

  generateMapCallback() {
    this.setState({
      isDrawMap: false,
    });
  }

  closeModal() {
    this.setState({
      isOpenModal: false,
    });
  }

  render() {
    const {
      isLoading,
      isLoadTimeZone,
      isShowResult,
      timezoneList,
      selectedTime,
    } = this.state;
    const { t } = this.props;

    return (
      <div className="time-zone">
        <div className="content">
          {
            !isLoadTimeZone ? (
              <div className="setting_small_box setting_small_box_2">
                <div className="content-wrapper">
                  <div
                    className="select_area custom"
                  >
                    <Input
                      icon="search"
                      loading={isLoading}
                      placeholder={t('system.message.search_for_timezone')}
                      value={selectedTime.name}
                      onChange={this.handleSearchChange}
                      onFocus={this.handleSearchFocus}
                      onBlur={this.handleSearchBlur}
                    />
                    <ResultRenderer
                      results={timezoneList}
                      handleResultSelect={this.handleResultSelect}
                      isShowResult={isShowResult}
                      translate={t}
                    />
                  </div>
                </div>
                <TimezonePicker
                  isDrawMap={this.state.isDrawMap}
                  isLoadTimeZone={isLoadTimeZone}
                  selectedTime={this.state.selectedTime}
                  generateMapCallback={this.generateMapCallback}
                  setValue={this.setValue}
                />
                <div className="setting_bottom">
                  {!selectedTime.name ? (
                    <a className="save" style={{ pointerEvents: 'none', opacity: '0.5' }}>{t('modal.button.save')}</a>
                  ) : (
                    <a className="save" onClick={this.handleSave} style={{ cursor: 'pointer' }}>
                      {t('modal.button.save')}
                    </a>
                  )}
                </div>
              </div>
            ) : (
              <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
                {t('modal.message.loading')}
              </Loader>
            )
          }
        </div>
        <Modal open={this.state.isOpenModal} onClose={this.closeModal}>
          {
            this.state.isLoader ? (
              <ClarLoader />
            ) : (
              <div className="modal_popup_wrap confirm_wrap">
                <div className="modal_popup_box confirm_box">
                  <div className="modal_popup confirm">
                    <h2 className="title">{t('modal.title.attention')}</h2>
                    <p className="text">{t('system.message.change_location')}</p>
                    <div className="button_wrap">
                      <a onClick={this.closeModal} className="left_button">
                        {t('modal.button.no')}
                      </a>
                      <a onClick={this.setTimeZone} className="right_button">
                        {t('modal.button.yes')}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            )
          }
        </Modal>
      </div>
    );
  }
}

export default withTranslation()(TimeZoneSystem);
